import React, { useContext } from "react";
import { RouteComponentProps } from "react-router-dom";
import { CourseContext } from "../../Store";
import Boundary from "components/Boundary";
import { DiscussProvider } from "./provider";
import { TopicType } from "../../../../API/discuss";
import useBatchPicker from "../../../main/utils/useBatchPicker";
import { AskTeacherDetailInner } from "../../../AskTeacher/AskTeacherDetail";

type DiscussDetailProps = RouteComponentProps<{ uuid: string }>;

export function DiscussDetail({ match }: DiscussDetailProps) {
    const { uuid } = match.params;

    const { batch } = useBatchPicker();

    const {
        course: { courseNo, courseSeq }
    } = useContext(CourseContext);

    return (
        <DiscussProvider
            topicType={TopicType.Discuss}
            uuid={uuid}
            courseNo={courseNo}
            batchNo={batch!}
            courseSeq={courseSeq}>
            <Boundary>
                <AskTeacherDetailInner />
            </Boundary>
        </DiscussProvider>
    );
}
